<template>
  <v-app-bar color="white" class="text-red">
    <v-app-bar-title>
      <router-link to="/">
        <img :src="logoImage" style="max-height: 75px; margin-top: 0px; vertical-align: middle;" alt="logo" />
      </router-link>
    </v-app-bar-title>
    <v-btn v-if="!authorize" variant="outlined" to="/login">ログイン</v-btn>
    <template v-if="authorize">
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-avatar color="secondary" v-bind="props" class="mr-2" style="cursor: pointer" @click="onClickImage()">
            {{ user.name.slice(0, 1) }}
          </v-avatar>
        </template>
        <v-card class="mx-auto" width="300">
          <template v-slot:title>
            {{ user.name }}
          </template>
        </v-card>

        <v-divider></v-divider>
        <v-list density="compact" nav>
          <v-list-item prepend-icon="mdi-account" title="マイページ" value="mypage" to="/mypage"></v-list-item>
          <v-list-item prepend-icon="mdi-logout" title="ログアウト" value="logout" @click="logout()"></v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-app-bar>
</template>


<script>
import axios from 'axios'
import logoImage from '@/assets/logo_02.png'

export default {
  name: 'TopBar',
  data: () => ({
    logoImage,
    authorize: false,
    userid: null,
    token: "",
    user: null,
  }),
  created: function () {
    axios.get(
      process.env.VUE_APP_API_URL + '/api/logincheck',
      { headers: { "Authorization": JSON.stringify(this.$store.getters.getToken) } }
    ).then(response => {
      console.log(response.data)
      console.log(response.status)
      if (response.status == 200) {
        this.user = response.data.user
        this.authorize = true
      } else {
        this.authorize = false
      }
    }).catch(err => {
      console.log(err) // mockData
      this.authorize = false
    })
  },
  methods: {
    logout() {
      this.$store.dispatch('removeToken')
      this.authorize = false
    },
    onClickImage() {
      console.log("onClickImage")
    }
  },
}
</script>
